import React from 'react';
import Alert from '@material-ui/core/Alert';
import { Box } from '@material-ui/core'
import { Trans, useTranslation } from 'react-i18next';

function DominioNoDisponible({ dominio, eventDomain }) {
  const {t} = useTranslation();

  return (
    <Box mt={3}>
      {eventDomain === 'domainregister' && <Alert severity="error"><strong>{dominio}:</strong> {t('notAvailableForRegistration')}</Alert>}
      {eventDomain === 'domaintransfer' &&
        <Alert severity="error"><strong>{dominio}: </strong>
        <Trans
          i18nKey="notEligibleForTransfer"
          components={{
            br: <br/>
          }}
        />
        </Alert>}

    </Box>
  )
}

export default DominioNoDisponible;